<template>
  <v-container class="fill-height d-flex align-center justify-center">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <loading-spinner v-if="isLoading"></loading-spinner>

        <v-card v-else class="pa-6" elevation="10" rounded="lg">
          <!-- 제목 -->
          <v-card-title class="text-h5 font-weight-bold text-center">
            {{ $t('label.iskal') }}
          </v-card-title>
          <!-- <v-card-subtitle class="text-center mb-4">
            {{ $t('txt.signup_description') }}
          </v-card-subtitle> -->

          <v-form v-model="valid">
            <v-card-text>
              <!-- 이름 입력 -->
              <v-text-field v-model="member.name" :label="$t('label.name')" :rules="requiredRules"
                @keyup.enter="handleSubmit" required outlined dense>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-account</v-icon>
                </template>
              </v-text-field>

              <!-- 영문 이름 -->
              <v-text-field v-model="member.name_eng" :label="$t('label.name_eng')" :rules="requiredRules"
                @keyup.enter="handleSubmit" required outlined dense>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-account</v-icon>
                </template>
              </v-text-field>

              <!-- 전화번호 -->
              <v-text-field v-model="member.phone" :label="$t('label.phone')" :rules="phoneRules"
                @keyup.enter="handleSubmit" required outlined dense>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-phone</v-icon>
                </template>
              </v-text-field>

              <!-- 소속 -->
              <v-text-field v-model="member.organization" :label="$t('label.organization')" :rules="requiredRules"
                @keyup.enter="handleSubmit" required outlined dense>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-briefcase</v-icon>
                </template>
              </v-text-field>

              <!-- 직위 -->
              <v-text-field v-model="member.position" :label="$t('label.position')" :rules="requiredRules"
                @keyup.enter="handleSubmit" required outlined dense>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-briefcase</v-icon>
                </template>
              </v-text-field>

              <!-- 이메일 입력 -->
              <v-text-field v-model="member.email" :label="$t('label.email')" :rules="emailRules"
                @keyup.enter="handleSubmit" required outlined dense>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-email</v-icon>
                </template>
              </v-text-field>

              <!-- 비밀번호 입력 -->
              <v-text-field v-model="member.password" :label="$t('label.password')" type="password"
                @keyup.enter="handleSubmit" :rules="passwordRules" required outlined dense>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-lock</v-icon>
                </template>
              </v-text-field>

              <!-- 회원가입 버튼 -->
              <v-card-actions class="mt-3">
                <v-spacer></v-spacer>
                <custom-button @click="handleSubmit" :label="$t('label.register')" :disabled="!valid" color="primary"
                  size="lg" gradient block></custom-button>
              </v-card-actions>
            </v-card-text>

            <!-- 소셜 로그인 -->
            <v-card-text>
              <p class="text-center grey--text mb-3">or sign up with</p>
              <div class="d-flex justify-center">
                <v-btn icon class="social-login-btn mx-2" @click="signupWithNaver">
                  <v-img src="/img/authlogo/naver-mini.png" contain height="40" width="40"></v-img>
                </v-btn>

                <v-btn icon class="social-login-btn mx-2" @click="signupWithKakao">
                  <v-img src="/img/authlogo/kakao-mini.png" contain height="40" width="40"></v-img>
                </v-btn>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>


  </v-container>
</template>

<script>
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import requestNaverAuthCode from '@/utils/naver';
import { authApi } from '@/api/api';
import CustomButton from '@/components/common/buttons/CustomButton.vue';

const current_domain = window.location.origin;
const kakaoRedirectUrl = `${current_domain}${process.env.VUE_APP_KAKAO_SIGNUP_REDIRECT_URL}`;
const naverRedirectUrl = `${current_domain}${process.env.VUE_APP_NAVER_SIGNUP_REDIRECT_URL}`;

export default {
  components: {
    LoadingSpinner,
    CustomButton,
  },
  data() {
    return {
      member: {
        name: '',
        name_eng: '',
        phone: '',
        organization: '',
        position: '',
        email: '',
        password: '',
      },
      isLoading: false,
      valid: false,
    };
  },
  computed: {
    requiredRules() {
      return [
        v => !!v || this.$t('valid.required_field')
      ];
    },
    emailRules() {
      return [
        v => !!v || this.$t('valid.required_email'),
        v => /.+@.+\..+/.test(v) || this.$t('valid.invalid_email')
      ];
    },
    phoneRules() {
      return [
        v => !!v || "전화번호를 입력하세요.",
        v => /^\d+$/.test(v) || "숫자만 입력할 수 있습니다.",
        v => /^\d{10,15}$/.test(v) || "15자 이하의 숫자로 입력해주세요."
      ];
    },
    passwordRules() {
      return [
        v => !!v || this.$t('valid.required_password'),
        v => v.length >= 8 || this.$t('valid.min_password')
      ];
    }
  },
  methods: {
    signupWithKakao() {
      Kakao.Auth.authorize({ redirectUri: kakaoRedirectUrl });
    },
    signupWithNaver() {
      requestNaverAuthCode(naverRedirectUrl);
    },
    async handleSubmit() {
      if (!this.valid || !this.member.name || !this.member.name_eng || !this.member.phone || !this.member.organization || !this.member.position || !this.member.email || !this.member.password) {
        this.notifyVue("top", "center", this.$t('alert.invalid_form'), "danger");
        return;
      }

      this.isLoading = true;
      const body = {
        email: this.member.email,
        password: this.member.password,
        name: this.member.name,
        name_eng: this.member.name_eng,
        phone: this.member.phone,
        organization: this.member.organization,
        position: this.member.position,
      };

      try {
        const response = await authApi.signup(body);

        if (response && response.status === 201) {
          this.notifyVue("top", "center", this.$t('alert.signup_success'), "success");
          this.$router.push({ path: '/login' });
        }
      } catch (error) {
        if (error.response.status === 400 && error.response.data.code === "sns_registered") {
          const message = error.response.data.message;
          this.notifyVue('top', 'center', `${message} 계정으로 가입한 계정입니다.`, "danger");
          this.$router.push({ path: '/login' });
        } else if (error.response.status === 400 && error.response.data.code === "different_provider") {
          const message = error.response.data.message;
          this.notifyVue('top', 'center', `${message}로 가입한 계정입니다.`, "danger");
          this.$router.push({ path: '/login' });
        } else if (error.response.status === 400 && error.response.data.code === "already_register") {
          this.notifyVue('top', 'center', "이미 회원가입된 이메일입니다.", "danger");
          this.$router.push({ path: '/login' });
        } else {
          this.notifyVue('top', 'center', "회원가입에 실패했습니다.", "danger");
        }
      } finally {
        this.isLoading = false;
      }
    },
    notifyVue(verticalAlign, horizontalAlign, alertMessage, alert_type) {
      this.$notify({
        timeout: 8000,
        message: alertMessage,
        icon: "priority_high",
        type: alert_type || "danger",
        horizontalAlign,
        verticalAlign,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fill-height {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-login-btn {
  border-radius: 50%;
  transition: 0.3s;
}

.social-login-btn:hover {
  transform: scale(1.1);
}

.v-card {
  background-color: white;
  border-radius: 12px;
}

.v-card-title {
  font-size: 1.3rem;
  font-weight: bold;
}

.v-card-subtitle {
  font-size: 1rem;
  color: #757575;
}
</style>
